import type { ReactElement } from 'react'

import { Typography } from '@twisto/components/atoms/typography'

type Props = {
  primary: ReactElement | string
  secondary?: ReactElement | string
}

export const DropDownItemText = ({ primary, secondary }: Props) => (
  <>
    <Typography data-testid="dropdown-item-text" variant="b3">
      {primary}
    </Typography>
    {secondary !== undefined ? (
      <Typography color="textSecondary" variant="b2">
        {secondary}
      </Typography>
    ) : null}
  </>
)
